import script from "./PlatformElementFormGradeAndStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformElementFormGradeAndStatus.vue?vue&type=script&setup=true&lang=js"

import "./PlatformElementFormGradeAndStatus.vue?vue&type=style&index=0&id=1db7e44b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db7e44b"]])

export default __exports__